<script setup>
import { useCooldown } from "@/utils/resendCodeTimer"

const emit = defineEmits(["resend"])

const { remaining, startCooldown } = useCooldown("code-resend", 60)

function handleClick() {
  emit("resend")
  startCooldown()
}

</script>

<template>
  <button :disabled="remaining > 0" @click="handleClick">
    <span v-if="remaining === 0" class="tertiary-mwi body-3-semi-bold mt-2 underline">Resend Code</span>
    <span v-else>Resend in {{ remaining }}s</span>
  </button>
</template>